import {
  createHideOfferModel,
  THideOfferResponseScheme,
  IHideOfferRequestScheme,
} from '@cian/api-models/hidden-objects/v1/hide-offer-website';
import { IHttpApi } from '@cian/http-api/shared';

export function postHideOffer(
  httpApi: IHttpApi,
  parameters?: IHideOfferRequestScheme,
): Promise<THideOfferResponseScheme> {
  return httpApi.fetch(createHideOfferModel({ parameters }), undefined);
}
